import React from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';
import Input from '../Input';
import { phoneMask } from '../../utils/masks';

export default function PhoneInput({ errors, values, handleChange }) {
  return (
    <div className="input-group mb-3 row">
      <div className="col-4 ">
        <Input
          disabled
          className={classnames({
            'is-invalid': errors.country,
          })}
          value={values.country || '+55'}
          name="country"
          onChange={handleChange}
          type="tel"
        />
      </div>
      <div className="col-8">
        <Input
          mask={phoneMask}
          autoFocus
          className={classnames({
            'is-invalid': errors.phone || errors.phoneNumber,
          })}
          value={values.phone || values.phoneNumber}
          name="phone"
          type="tel"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

PhoneInput.propTypes = {
  errors: propTypes.object.isRequired,
  values: propTypes.object.isRequired,
  handleChange: propTypes.func.isRequired,
};
